import React from "react";
import { Typography } from '@mui/material';


export const formatDateUpload = (patientRow) => {
        const parsedDate = new Date(patientRow?.latestUploadedAt);
        const day = parsedDate.getDate().toString().padStart(2, '0');
        const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
        const year = parsedDate.getFullYear();
        const reformattedDate = `${day}/${month}/${year}`
        return (
            <Typography sx={{ fontSize: '1rem' }}>
                {reformattedDate}
            </Typography>);

};

